import { StepId } from '../../api/useRiskToleranceWorkflowQuery';

export interface FormValues {
  [StepId.EmergencyHandling]: number;
}

export const title =
  'How able are you to handle financial emergencies with assets outside of your investments account(s)?';

export const options = [
  { label: 'Very able', value: 1 },
  { label: 'Mostly', value: 2 },
  { label: 'Able', value: 3 },
  { label: 'Somewhat able', value: 4 },
  { label: 'Unable', value: 5 },
];
